// import ToastError from "@/components/Base/toast/Error.vue";
import ToastError from "@/layers/base/components/toast/Error.vue";
import { useToast } from 'vue-toastification';

export default function ({ title = '', message = 'Something went wrong' }) {
  const rateLimitHit = useState<boolean>('rate-limit-hit')

  return useToast().error({
      component: ToastError,
      props: {
        title: title,
        message: message,
      },
    },
    {
      toastClassName: "error-toast",
      hideProgressBar: true,
      icon: false,
      closeButton: false,
      timeout: rateLimitHit.value ? 60 * 1000 : 3000, // 1 minute or 3 seconds
    })
}
